module.exports = __webpack_public_path__ + "fonts/icomoon.6312a442.ttf";